/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createRevokeOrganizationApiKeyResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type RevokeOrganizationApiKeyResponse } from '../../../../models/index.js';
// @ts-ignore
import { RotateRequestBuilderRequestsMetadata, type RotateRequestBuilder } from './rotate/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/api-keys/{keyId}
 */
export interface WithKeyItemRequestBuilder extends BaseRequestBuilder<WithKeyItemRequestBuilder> {
    /**
     * The rotate property
     */
    get rotate(): RotateRequestBuilder;
    /**
     * Permanently revokes the key. This cannot be undone and stops every holder of the value immediately. Rotate instead when the integration should keep working under a new value.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<RevokeOrganizationApiKeyResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 401 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     delete(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<RevokeOrganizationApiKeyResponse | undefined>;
    /**
     * Permanently revokes the key. This cannot be undone and stops every holder of the value immediately. Rotate instead when the integration should keep working under a new value.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithKeyItemRequestBuilderUriTemplate = "{+baseurl}/api/organizations/api-keys/{keyId}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithKeyItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithKeyItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    rotate: {
        requestsMetadata: RotateRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithKeyItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: WithKeyItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createRevokeOrganizationApiKeyResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
